import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { audienceQueryLinkerSchema } from './audience-query-linker-schema';

export const audienceQuerySchema = z.object({
  ...audienceQueryLinkerSchema.shape,
  plural: z.string().nullable(),
  status: statusQuerySchema,
  clients_count: z.number(),
});

export type AudienceQuerySchema = z.infer<typeof audienceQuerySchema>;

export const audienceQueryAllSchema = paginatedResponseSchema(audienceQuerySchema);
export type AudienceQueryAllSchema = z.infer<typeof audienceQueryAllSchema>;
